"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDialogStyles = exports.dialogVars = exports.dialogCommon = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var dialogCommon = exports.dialogCommon = ["height", "width", "zIndex", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"];
var dialogVars = exports.dialogVars = (0, _initVars.default)({
  applied: dialogCommon,
  variables: [{
    key: "fill"
  }]
});
var styles = function styles(theme) {
  return {
    variables: dialogVars.styles,
    defaultDialogBoxStyles: {
      padding: theme.spacing.base * 3,
      minWidth: theme.spacing.base * 34,
      lineHeight: theme.typography.lineHeight,
      whiteSpace: "pre-line",
      width: theme.spacing.base * 80
    },
    small: {
      maxWidth: theme.spacing.base * 40,
      width: "60vw"
    },
    root: {
      width: "100%",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start"
    },
    title: {
      display: "inline-flex",
      alignItems: "center",
      gap: 4,
      fontFamily: "inherit",
      fontSize: theme.typography.fontSize + 4,
      color: theme.colors.baseContrast085,
      marginBottom: theme.spacing.base * 2,
      marginTop: 0
    },
    svgIcon: {
      fill: dialogVars.get("fill"),
      marginTop: 0
    },
    content: {
      width: "100%",
      textOverflow: "ellipsis",
      overflow: "hidden",
      fontFamily: "inherit",
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.fontSize + 2,
      color: theme.colors.baseContrast070,
      margin: 0,
      textWrap: "pretty"
    },
    actions: {
      flexWrap: "wrap-reverse",
      alignSelf: "flex-end",
      marginTop: theme.spacing.base * 3
    },
    button: {
      alignSelf: "flex-end",
      "& label": {
        color: theme.colors.baseContrast050
      },
      "&:last-child > label": {
        color: theme.colors.primary
      }
    },
    noContent: {
      margin: 0
    }
  };
};
var useDialogStyles = exports.useDialogStyles = (0, _createUseStyles.default)(styles, {
  name: "Dialog"
});